define('common/components/inactivity-modal/views/inactivity-modal',[
    'i18next',
    'vue',
    'common/components/vue-wrapper/helpers/mount-vue-component',
    '@discoveryedu/platform-components'
], function (i18next, Vue, mountVueComponent, PlatformComponents) {
    'use strict';

    return Mn.ItemView.extend({

        "template": false,

        "initialize": function(options) {
            this.model = options.model;
            this.inactivityModalApp = null;
            this.modalProps = Vue.reactive({});

            // Save initial props from the model
            this.updateReactiveProps();

            // And update props when the model changes
            this.listenTo(this.model, 'change', this.updateReactiveProps);
        },

        "updateReactiveProps": function() {
            this.modalProps.firstName = this.model.get('firstName') || this.model.get('first_name');
            this.modalProps.isSystemDown = this.model.get('isSystemDown');
            this.modalProps.isLoginPrompted = this.model.get('isLoginPrompted');
            this.modalProps.popupBlocked = this.model.get('popupBlocked');
            this.modalProps.isLTIUser = this.model.get('isLTIUser');
            this.modalProps.hideFooter = this.model.get('hideFooter');
            this.modalProps.hideLogin = this.model.get('hideLogin');
        },

        "render": function() {
            var self = this;
            $('<div id="inactivity-modal-container"></div>').appendTo('body');

            this.inactivityModalApp = mountVueComponent(
                {
                    "name": 'InactivityModalApp',
                    "render": function () {
                        // We need to use a custom render function here instead of passing
                        // PlatformComponents.InactivityModal directly, so that the props
                        // stay reactive
                        return Vue.h(
                            PlatformComponents.InactivityModal,
                            _.extend({}, self.modalProps, {
                                "onCloseModal": function() {
                                    self.dismiss();
                                },
                                "onSave": function() {
                                    self.trigger('save');
                                },
                                "onFocusWindow": function() {
                                    self.trigger('click:focus-window');
                                }
                            })
                        );
                    }
                },
                '#inactivity-modal-container'
            );

            return this;
        },

        "dismiss": function() {
            this.trigger('dismiss'); // the inactivity behavior listens to this
            this.onDestroy();
        },

        "showFooter": function() {
            this.model.set('hideFooter', false);
        },

        "hideFooter": function() {
            this.model.set('hideFooter', true);
        },

        "hideLogin": function() {
            this.model.set('hideLogin', true);
        },

        "onDestroy": function() {
            if (this.inactivityModalApp) {
                this.inactivityModalApp.unmount();
                $('#inactivity-modal-container').remove();
                this.inactivityModalApp = null;
            }
        }
    });
});

